var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.21057C0 5.32495 0 4.38214 0.585786 3.79636C1.17157 3.21057 2.11438 3.21057 4 3.21057H17C18.8856 3.21057 19.8284 3.21057 20.4142 3.79636C21 4.38214 21 5.32495 21 7.21057V7.73689C21 8.20829 21 8.44399 20.8536 8.59044C20.7071 8.73689 20.4714 8.73689 20 8.73689H1C0.528595 8.73689 0.292893 8.73689 0.146447 8.59044C0 8.44399 0 8.20829 0 7.73689V7.21057Z",
    fill: "#1D5AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 19.8856 0 20.8284 0.585786 21.4142C1.17157 22 2.11438 22 4 22H17C18.8856 22 19.8284 22 20.4142 21.4142C21 20.8284 21 19.8856 21 18V11.9474C21 11.476 21 11.2403 20.8536 11.0938C20.7071 10.9474 20.4714 10.9474 20 10.9474H1C0.528595 10.9474 0.292893 10.9474 0.146447 11.0938C0 11.2403 0 11.476 0 11.9474V18Z",
    fill: "#1D5AB9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1L5.25 4.31579",
    stroke: "#1D5AB9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 1L15.75 4.31579",
    stroke: "#1D5AB9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResDateIcon);
export default __webpack_public_path__ + "static/media/res_dateIcon.a663db45e5f3bf3bb545a35b6f7a612d.svg";
export { ForwardRef as ReactComponent };